
export enum EstadoNotificacionEnum {
  APROBADO = 'APROBADO',
  RECHAZADO = 'RECHAZADO',
  PENDIENTE = 'PENDIENTE',
  EXPIRADO = 'EXPIRADO'
}

export const ESTADO_NOTIFICACION_INVENTARIO_LABELS = [
  'TODOS',
  EstadoNotificacionEnum.APROBADO,
  EstadoNotificacionEnum.RECHAZADO,
  EstadoNotificacionEnum.PENDIENTE,
  EstadoNotificacionEnum.EXPIRADO
]
